import { Form, Input, Button, notification } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { postSignIn } from "services/SauceService";
import { useDispatch } from "react-redux";
import { getBusinessInfo, getBusinessess } from "redux-context/business";
import { getLoggedUserInfo } from "redux-context/user";
import { getDomainMetadata } from "redux-context/domain";
import { ReactComponent as Logo } from "assets/images/logo.svg";
import "./Login.scss";

const Login: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const [loading, setLoading] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  const [form] = Form.useForm();
  const [passwordVisible, setPasswordVisible] = useState(false);

  const onFinish = async () => {
    setLoading(true);
    const values = form.getFieldsValue(true);

    try {
      const response: any = await postSignIn(values);

      if (response?.accessToken) {
        localStorage.setItem("token", response.accessToken);
        if (response.businessId)
          localStorage.setItem("businessId", response.businessId);

        dispatch(getBusinessess());
        dispatch(getBusinessInfo());
        dispatch(getDomainMetadata());
        dispatch(getLoggedUserInfo());

        const returnURL = sessionStorage.getItem("returnURL");
        sessionStorage.removeItem("returnURL");

        if (returnURL && returnURL !== "/login") navigate(returnURL);
        else navigate("/");
        return;
      }

      api.error({ message: "Error", description: "User without business" });
    } catch (error) {
      api.error({ message: "Error", description: "Invalid email or password" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      {contextHolder}

      <main id="login-container" className="login-wrapper">
        <div id="login-card" className="login-card">
          {/* Logo */}
          <div id="logo-section" className="logo-section">
            <div className="logo-row">
              <Logo className="login-logo" />
            </div>
          </div>

          {/* Header */}
          <div id="header-text" className="header-text">
            <h1 className="welcome-title">Welcome back</h1>
            <p className="welcome-sub">
              Please enter your details to Log in to your account.
            </p>
          </div>

          {/* Form */}
          <Form
            id="login-form"
            form={form}
            name="login"
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
            className="login-form"
          >
            {/* Email */}
            <Form.Item
              className="field"
              label={
                <span className="field-label">
                  Email address <span className="req">*</span>
                </span>
              }
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input
                className="custom-input"
                placeholder="name@company.com"
                size="large"
                suffix={<MailOutlined className="input-suffix" />}
              />
            </Form.Item>

            {/* Password (label + forgot na mesma linha, igual HTML) */}
            <Form.Item
              className="field"
              label={
                <div className="password-label-row">
                  <span className="field-label">
                    Password <span className="req">*</span>
                  </span>

                  <Link className="forgot-link-inline" to="/forgot-password">
                    Forgot password?
                  </Link>
                </div>
              }
              name="password"
              rules={[
                { required: true, message: "Please input your password!" },
              ]}
            >
              <div className="password-wrapper">
                <Input
                  className="custom-input"
                  placeholder="Enter your password"
                  size="large"
                  type={passwordVisible ? "text" : "password"}
                />

                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setPasswordVisible((v) => !v)}
                  aria-label="Toggle password visibility"
                >
                  {passwordVisible ? (
                    <i className="fa-regular fa-eye-slash" />
                  ) : (
                    <i className="fa-regular fa-eye" />
                  )}
                </button>
              </div>
            </Form.Item>

            <Button
              id="submit-btn"
              type="primary"
              htmlType="submit"
              className="signin-button"
              loading={loading}
              block
            >
              Log in
            </Button>

            <div id="register-link" className="register-link">
              <p>
                Don't have an account?{" "}
                <a
                  href="https://www.mustard.love/welcome"
                  className="create-link"
                >
                  Create an account
                </a>
              </p>
            </div>

            <div className="terms-text">
              <p>
                By clicking "Create an account", you agree to our{" "}
                <a
                  href="https://www.mustard.love/terms-of-service"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of Service
                </a>{" "}
                and{" "}
                <a
                  href="https://www.mustard.love/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </div>
          </Form>
        </div>
      </main>
    </div>
  );
};

export default Login;
